<template>
  <div class="c-modal-manager">
    <template v-for="modal in modals">
      <component :is="modal.component" :key="`${ modal.name }-${ modal.id }`" :modal="{ id: modal.id, name: modal.name }"></component>
    </template>    
  </div>
</template>

<script>
  // Vuex
  import { mapActions, mapGetters } from 'vuex';

  // Utilities
  import { addNoScroll, removeNoScroll } from '@/utilities';

  let _noScrollIsActive = false;

  export default {
    name: 'ModalManager',
    
    computed: {
      ...mapGetters([
        'modals'
      ])
    },

    watch: {
      'modals': function (val, oldVal) {
        if (val.length > 0) {
          if (_noScrollIsActive) return;
          
          _noScrollIsActive = true;
          addNoScroll();
        } else {
          // TODO: TO STOP MODAL JUMPING WHEN REMOVING NO SCROLL PADDINGRIGHT NEEDS TO BE APPLIED ON MOUNT AND REMOVED ON DESTROY.
          // HOWEVER THIS ALSO INTRODUCES ISSUES WITH FULLSCREEN AND NESTED MODALS
          _noScrollIsActive = false;
          removeNoScroll();
        }
      }
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/plugins/modals/ModalManager.vue